export default "__VITE_ASSET__sC7zkE$M__"